module.exports = __webpack_public_path__ + "files/0b322892d3efc830b6018b37deff32c1.png";